import changeDateDay from './changeDateDay';
import correctDateFormat from './correctDateFormat';

const calcStartEndDates = (weekDate?: string) => {
  const startDate = weekDate
    ? new Date(correctDateFormat(weekDate))
    : new Date();

  startDate.setDate(startDate.getDate() - startDate.getDay());

  const endDate = changeDateDay(startDate, 6);

  return { startDate, endDate };
};

export default calcStartEndDates;
